import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { getShootbackBatch, updateShootback } from '../api';

export const shootbackKeys = {
  batch: (macs: string[]) => ['shootback', 'batch', macs] as const,
};

export function useShootback(macs: string[]) {
  return useQuery({
    queryKey: shootbackKeys.batch(macs),
    queryFn: () => getShootbackBatch(macs),
    enabled: macs.length > 0,
    staleTime: 30 * 1000,
  });
}

export function useToggleShootback() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ mac, enabled }: { mac: string; enabled: boolean }) =>
      updateShootback(mac, enabled),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shootback'] });
      toast.success('Shootback updated');
    },
    onError: () => {
      toast.error('Failed to update shootback');
    },
  });
}
